/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/localization/messages',[], function() {
    'use strict';
    var values = {
        dashboard: {},
        analyticsChart: {},
        zoning: {
            syncNotComplete: 'Floor map based analytics are not available because server data is synchronizing and processing for the first time.',
            locationNotFound: 'Location no longer exists.',
            noZones: 'There are no zones on this floor',
            noLayout: 'Floor map based analytics cannot be displayed because no floor plan is available for this location.',
            // handlebar style
            dimensionValue: '{{length}} x {{width}} {{sqUnits}}',
            zoneDeleted: 'Deleted Zone',
            deviceDataMismatch: 'Volume of data reported per device might vary if devices are added and/or removed from the floor map at different times.',
            timezoneMismatch: 'Floor map timezone might vary from the reporting location timezone.'
        },
        global: {
            locationNotAvailable: 'Location not Available',
            timezoneMismatch: ' End date for a widget might be a day ahead of the report generation date, in the case of child locations\' timezone mismatch.'
        }
    };
    return values;
});
